module.exports = __webpack_public_path__ + "static/media/included8.840b0e9f.svg";